import React, { useState } from "react";
import PageHeader from "../../components/common/PageHeader";
import StatsCardGroup from "../../components/common/StatsCardGroup";
import BarAnalyticsChart from "../../components/vendors/BarAnalyticsChart";
import {
  CurrencyDollarIcon,
  CalendarIcon,
  StarIcon,
  UserGroupIcon,
  ClockIcon,
} from "@heroicons/react/24/outline";
import {
  useAdminDashboardMonthlyBookings,
  useAdminDashboardSummary,
  useAdminDashboardVendorGrowth,
} from "../../custom-hooks/queries";

const AdminDashboard = () => {
  const currentYear = new Date().getFullYear();
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [selectedYear2, setSelectedYear2] = useState(currentYear);

  const handleYearChange = (year) => {
    setSelectedYear(year);
  };
  const handleYearChange2 = (year) => {
    setSelectedYear2(year);
  };
  // Stats data

  const { data, isLoading, isError } = useAdminDashboardSummary();
  const formatValue = (value, type) => {
    if (value === undefined || value === null) return "-";
    if (type === "currency") {
      if (value >= 1000) return `$${(value / 1000).toFixed(0)}k`;
      return `$${value}`;
    }
    if (type === "count") {
      if (value >= 1000) return `${(value / 1000).toFixed(0)}K`;
      return `${value}`;
    }
    return value;
  };
  const {
    data: vendorGrowthData,
    isLoading: isVendorGrowthLoading,
    isError: isVendorGrowthError,
  } = useAdminDashboardVendorGrowth(selectedYear);
  const {
    data: monthlyBookingsData,
    isLoading: isMonthlyBookingsLoading,
    isError: isMonthlyBookingsError,
  } = useAdminDashboardMonthlyBookings(selectedYear2);

  const stats = [
    {
      icon: <CurrencyDollarIcon className="h-6 w-6" />,
      label: "Total Vendors",
      value: formatValue(data?.data?.totalVendors, "count"),
    },
    {
      icon: <CalendarIcon className="h-6 w-6" />,
      label: "Pending Vendor Approvals",
      value: formatValue(data?.data?.pendingVendorApprovals, "count"),
    },
    {
      icon: <StarIcon className="h-6 w-6" />,
      label: "Total Experiences",
      value: data?.data?.totalExperiences || "-",
    },
    {
      icon: <UserGroupIcon className="h-6 w-6" />,
      label: "Pending Experiences Approval",
      value: formatValue(data?.data?.pendingExperienceApprovals, "count"),
    },
    {
      icon: <ClockIcon className="h-6 w-6" />,
      label: "Total Bookings",
      value: formatValue(data?.data?.totalBookings, "count"),
    },
  ];

  // Chart data matching Figma
  const vendorGrowthChartData =
    vendorGrowthData?.data?.monthly?.map((item) => ({
      month: item.month,
      value: item.vendors,
      vendors: item.vendors,
    })) || [];

  const monthlyBookingsChartData =
    monthlyBookingsData?.data?.monthly?.map((item) => ({
      month: item.month,
      value: item.bookings,
      bookings: item.bookings,
    })) || [];

  return (
    <div className="p-4 sm:p-6">
      <PageHeader
        title="Welcome back"
        description="Here's what's happening with your experiences today"
      />

      <div className="mt-4 sm:mt-6">
        <StatsCardGroup stats={stats} />
      </div>

      <div className="mt-4 sm:mt-6 grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6">
        <BarAnalyticsChart
          data={vendorGrowthChartData}
          showToggle={false}
          showFilters={false}
          showYearDropdown={true}
          heading="Vendor Growth"
          onYearChange={handleYearChange}
          selectedYear={selectedYear}
        />

        <BarAnalyticsChart
          data={monthlyBookingsChartData}
          showToggle={false}
          showFilters={false}
          showYearDropdown={true}
          heading="Monthly Bookings"
          onYearChange={handleYearChange2}
          selectedYear={selectedYear2}
        />
      </div>
    </div>
  );
};
export default AdminDashboard;
